import { MixpanelEvent, type TabProps } from '@talos/kyoko';
import { ActiveBatches } from './ActiveBatches';
import { BatchHistory } from './BatchHistory';
import { UnsettledTransactions } from './UnsettledTransactions';

export interface LpSettlementTabProps extends TabProps {
  render: () => React.ReactNode;
  route: string;
  mixpanelEvent: MixpanelEvent;
}

export const LP_SETTLEMENT_TABS: LpSettlementTabProps[] = [
  {
    label: 'Unsettled Transactions',
    route: 'unsettled-transactions',
    mixpanelEvent: MixpanelEvent.NavigateToPortfolioLpSettlementUnsettledTransactions,
    render: () => <UnsettledTransactions />,
  },
  {
    label: 'Active Batches',
    route: 'active-batches',
    mixpanelEvent: MixpanelEvent.NavigateToPortfolioLpSettlementActiveBatches,
    render: () => <ActiveBatches />,
  },
  {
    label: 'Batch History',
    route: 'batch-history',
    mixpanelEvent: MixpanelEvent.NavigateToPortfolioLpSettlementBatchHistory,
    render: () => <BatchHistory />,
  },
];
